const nf = new Intl.NumberFormat("id-ID", { maximumFractionDigits: 2 });
const nfCompact = new Intl.NumberFormat("id-ID", { notation: "compact", maximumFractionDigits: 1 });

export function fmt(n) {
  if (n === null || n === undefined || isNaN(n)) return "-";
  return nf.format(n);
}

export function fmtCompact(n) {
  if (n === null || n === undefined || isNaN(n)) return "-";
  return nfCompact.format(n);
}

// Soft-green fintech palette
export const CHART_COLORS = ["#1C4A37", "#7CC26A", "#B7E4A6", "#3E7C5A", "#A9CBB6", "#5FA777", "#9CA3AF"];

export const GREEN = {
  dark: "#1C4A37",
  mid: "#5FA777",
  light: "#A5D983",
  pale: "#C7E9B8",
  grid: "#E4ECE5",
  axis: "#8A9A90",
};
